import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    // name: 'index',
    component: () => import('@/views/index.vue'),
    meta: { title: 'GamingUtility' }
  }, {
    path: "/98KTZ",
    component: () => import('@/views/clients/taodi/KG698U/index.vue'),
    meta: { title: '98KTZ' }
  }, {
    path: '/kong',  // 此为空页面
    component: () => import('@/pages/9354/index.vue')
  }

]

const router = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();

});

export default router
